/**
 * How a roster swing's confirmation status is shown — the one place the grid
 * outline, the Swing Responses tab and My Shifts take it from, so they cannot disagree.
 * Plan: docs/features/roster-swing-acceptance-plan.md (D-07).
 *
 * The grid shows status as an OUTLINE, never a fill: cell fills already mean
 * shift and leave codes (AL_NCR is yellow, SSE and OS are green).
 */
import type { SwingStatus } from './planner/plannerService';

/** StatusBadge key for each swing status. */
export const SWING_BADGE: Record<SwingStatus, string> = {
  posted: 'awaiting_response',
  accepted: 'accepted',
  declined: 'declined',
  dismissed: 'dismissed',
  withdrawn: 'cancelled',
};

/** Outline colour on the planner grid (amber-500 / green-600 / red-600). */
export const SWING_OUTLINE: Partial<Record<SwingStatus, string>> = {
  posted: '#f59e0b',
  accepted: '#16a34a',
  declined: '#dc2626',
  dismissed: '#dc2626',
};

export const SWING_STATUS_TEXT: Record<SwingStatus, string> = {
  posted: 'Awaiting response',
  accepted: 'Accepted',
  declined: 'Declined',
  dismissed: 'Dismissed',
  withdrawn: 'Withdrawn',
};

/** "Mon 2 Nov 2026" for a 'YYYY-MM-DD' day key, read as a calendar day. */
export function swingDayLabel(key: string, withYear = true): string {
  return new Date(`${key}T00:00:00Z`).toLocaleDateString('en-AU', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(withYear ? { year: 'numeric' } : {}),
    timeZone: 'UTC',
  });
}

export function swingDayCount(s: { start: string; end: string }): number {
  return Math.round((Date.parse(s.end) - Date.parse(s.start)) / 86_400_000) + 1;
}
